module.exports = __webpack_public_path__ + "img/gift5.d30f46e8.png";